<template>
  <div class="fill-height">
    <v-container class="fill-height text-center">
      <v-row align="center" justify="center">
        <v-col cols="12" xs="12">
          <v-progress-circular
            :size="70"
            :width="7"
            color="secondary"
            indeterminate
          />
        </v-col>
        <v-col cols="12" xs="12">
          <h1 class="primary--text">Cargando Aplicación</h1>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Loading",
  computed: {
    ...mapState({
      user: state => state.auth.user,
      auth_token: state => state.auth.auth_token
    })
  },
  async created() {
    await this.$store.dispatch("getChoices");
    await this.$store.dispatch("roles/getRoles");
    await this.$store.dispatch("locations/getStates");
    await this.$store.dispatch("locations/getCities");
    await this.$store.dispatch("locations/getCountries");

    if (this.auth_token && this.user && this.user.role.slug) {
      if (this.user.role.slug == "admin" || this.user.role.slug == "vet") {
        await this.$store.dispatch(
          "stock/getStockWithoutPagination",
          this.auth_token
        );

        await this.$store.dispatch("users/getUserWithoutPagination", {
          owner: true,
          token: this.auth_token,
          vet: this.user.role.slug == "admin"
        });

        await this.$store.dispatch(
          "inventories/getInventoriesWithoutPagination",
          {
            assign: false,
            no_assign: false,
            token: this.auth_token
          }
        );

        await this.$store.dispatch("pets/getPetsWithoutPag", this.auth_token);
      }

      this.$router.replace(this.user.role.slug == "admin" ? "/inventories" : "/pets");
    }
  }
};
</script>
